import { HtmlButton, type HtmlButtonProps } from "@hopper-ui/components";
import { AngleLeftIcon, AngleRightIcon } from "@hopper-ui/icons";

interface CollapseButtonProps extends Omit<HtmlButtonProps, "aria-label"> {
    direction: "left" | "right";
    "aria-label": string;
}

export function CollapseButton(props: CollapseButtonProps) {
    const { direction, ...rest } = props;

    return (
        <HtmlButton
            display="flex"
            padding="inset-xs"
            justifyContent="center"
            alignItems="center"
            borderRadius="circle"
            border="neutral"
            borderHover="neutral-active"
            backgroundColor="neutral"
            backgroundColorHover="neutral-hover"
            backgroundColorActive="neutral-press"
            color="neutral"
            colorHover="neutral-hover"
            colorActive="neutral-press"
            cursor="pointer"
            {...rest}
            style={{
                outlineColor: "var(--hop-primary-border-focus)",
                transition: "all var(--hop-easing-duration-1) var(--hop-easing-focus)",
                ...rest.style
            }}
        >
            {direction === "left" ? <AngleLeftIcon size="sm" /> : <AngleRightIcon size="sm" />}
        </HtmlButton>
    );
}
